import { styled } from 'styled-components'

import { StyledInvoiceButton } from '../WonLot/WonLot'

export const StyledWonLotContainer = styled.div`
  ${StyledInvoiceButton} {
    color: ${({ theme }) => theme.colours.primary.white};
  }
`
